document.documentElement.classList.remove('no-js');

/* ---------- Cart Drawer ---------- */
const cartDrawer = document.getElementById('CartDrawer');
const cartOverlay = document.querySelector('.cart-drawer-overlay');

function openCartDrawer(){
  cartDrawer && cartDrawer.classList.add('is-open');
  cartOverlay && cartOverlay.classList.add('is-open');
  cartDrawer && cartDrawer.setAttribute('aria-hidden','false');
  fetchCartDrawer();
}
function closeCartDrawer(){
  cartDrawer && cartDrawer.classList.remove('is-open');
  cartOverlay && cartOverlay.classList.remove('is-open');
  cartDrawer && cartDrawer.setAttribute('aria-hidden','true');
}
document.querySelectorAll('[data-cart-drawer-open]').forEach(el=>{
  el.addEventListener('click', e=>{ e.preventDefault(); openCartDrawer(); });
});
document.querySelectorAll('[data-cart-drawer-close]').forEach(el=>{
  el.addEventListener('click', closeCartDrawer);
});

function fetchCartDrawer(){
  fetch('/cart.js')
    .then(r=>r.json())
    .then(cart=>{
      const itemsEl = document.querySelector('[data-cart-drawer-items]');
      const subtotalEl = document.querySelector('[data-cart-drawer-subtotal]');
      const countEls = document.querySelectorAll('[data-cart-count]');
      countEls.forEach(el=> el.textContent = cart.item_count);
      if(subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      if(!itemsEl) return;
      if(cart.items.length === 0){
        itemsEl.innerHTML = '<p class="empty-state">Your bag is empty.</p>';
        return;
      }
      itemsEl.innerHTML = cart.items.map(item => `
        <div class="cart-line" data-line-key="${item.key}">
          <img src="${item.image}" alt="${item.product_title}">
          <div>
            <p style="margin-bottom:.25rem;font-weight:500">${item.product_title}</p>
            <p style="font-size:.8rem;color:var(--color-muted-foreground);margin-bottom:.4rem">${item.variant_title || ''}</p>
            <p style="font-size:.85rem">${item.quantity} &times; ${formatMoney(item.price)}</p>
            <button class="remove-item" data-remove-line="${item.key}">Remove</button>
          </div>
        </div>
      `).join('');
      itemsEl.querySelectorAll('[data-remove-line]').forEach(btn=>{
        btn.addEventListener('click', () => removeCartLine(btn.dataset.removeLine));
      });
    });
}

function removeCartLine(key){
  fetch('/cart/change.js', {
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body: JSON.stringify({ id: key, quantity: 0 })
  }).then(()=> fetchCartDrawer());
}

function formatMoney(cents){
  return '$' + (cents/100).toFixed(2);
}

/* ---------- Add to cart (AJAX) ---------- */
document.querySelectorAll('[data-product-form]').forEach(form=>{
  form.addEventListener('submit', function(e){
    e.preventDefault();
    const formData = new FormData(form);
    const submitBtn = form.querySelector('[type="submit"]');
    if(submitBtn){ submitBtn.disabled = true; submitBtn.textContent = 'Adding...'; }
    fetch('/cart/add.js', { method:'POST', body: formData })
      .then(r=>r.json())
      .then(()=>{
        if(submitBtn){ submitBtn.disabled = false; submitBtn.textContent = 'Add to Bag'; }
        openCartDrawer();
      })
      .catch(()=>{
        if(submitBtn){ submitBtn.disabled = false; submitBtn.textContent = 'Add to Bag'; }
      });
  });
});

/* ---------- Quantity selectors ---------- */
document.querySelectorAll('.qty-selector').forEach(sel=>{
  const input = sel.querySelector('input');
  sel.querySelectorAll('button').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      let val = parseInt(input.value || '1', 10);
      val = btn.dataset.action === 'increase' ? val+1 : Math.max(1, val-1);
      input.value = val;
      input.dispatchEvent(new Event('change', {bubbles:true}));
    });
  });
});

/* ---------- Product gallery thumbs ---------- */
document.querySelectorAll('.product__gallery-thumbs img').forEach(thumb=>{
  thumb.addEventListener('click', ()=>{
    const main = document.querySelector('.product__gallery-main img');
    if(main) main.src = thumb.dataset.full || thumb.src;
    document.querySelectorAll('.product__gallery-thumbs img').forEach(t=>t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

/* ---------- Variant swatches ---------- */
document.querySelectorAll('.swatch-group').forEach(group=>{
  group.querySelectorAll('.swatch').forEach(sw=>{
    sw.addEventListener('click', ()=>{
      group.querySelectorAll('.swatch').forEach(s=>s.classList.remove('active'));
      sw.classList.add('active');
      const hiddenInput = group.closest('[data-product-form]')?.querySelector(`input[name="${group.dataset.option}"]`);
      if(hiddenInput) hiddenInput.value = sw.dataset.value;
    });
  });
});

/* ---------- Mobile nav ---------- */
const menuToggle = document.querySelector('.menu-toggle');
const siteNav = document.querySelector('.site-nav');
if(menuToggle && siteNav){
  menuToggle.addEventListener('click', ()=>{
    siteNav.classList.toggle('is-open');
  });
}

/* ---------- Cart count on load ---------- */
document.addEventListener('DOMContentLoaded', ()=>{
  fetch('/cart.js').then(r=>r.json()).then(cart=>{
    document.querySelectorAll('[data-cart-count]').forEach(el=> el.textContent = cart.item_count);
  });
});

/* ---------- Locale / currency dropdown ---------- */
document.querySelectorAll('[data-locale-selector]').forEach(wrapper=>{
  const toggle = wrapper.querySelector('[data-locale-toggle]');
  if(!toggle) return;
  toggle.addEventListener('click', (e)=>{
    e.stopPropagation();
    const isOpen = wrapper.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
  document.addEventListener('click', (e)=>{
    if(!wrapper.contains(e.target)){
      wrapper.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
  });
  document.addEventListener('keydown', (e)=>{
    if(e.key === 'Escape'){
      wrapper.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
  });
});

/* ---------- Collection: Load More (AJAX pagination, no page reload) ---------- */
(function(){
  const wrap = document.querySelector('[data-load-more-wrap]');
  if(!wrap) return;
  const grid = document.querySelector('[data-product-grid]');
  const btn = wrap.querySelector('[data-load-more]');
  const loader = wrap.querySelector('[data-loader]');

  function loadNext(url){
    if(!url) return;
    btn.hidden = true;
    loader.hidden = false;
    const sep = url.includes('?') ? '&' : '?';
    fetch(url + sep + 'section_id=main-collection')
      .then(r => r.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('[data-product-grid]');
        const newWrap = doc.querySelector('[data-load-more-wrap]');
        if(newGrid && grid){
          grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
        }
        loader.hidden = true;
        if(newWrap && !newWrap.hasAttribute('hidden')){
          const newBtn = newWrap.querySelector('[data-load-more]');
          const nextUrl = newBtn ? newBtn.dataset.nextUrl : null;
          if(nextUrl){
            btn.dataset.nextUrl = nextUrl;
            btn.hidden = false;
          } else {
            wrap.hidden = true;
          }
        } else {
          wrap.hidden = true;
        }
      })
      .catch(() => {
        loader.hidden = true;
        btn.hidden = false;
      });
  }

  btn.addEventListener('click', () => loadNext(btn.dataset.nextUrl));

  // Auto-load when the button scrolls into view (infinite scroll feel)
  if('IntersectionObserver' in window){
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(entry.isIntersecting && !btn.hidden){
          loadNext(btn.dataset.nextUrl);
        }
      });
    }, { rootMargin: '400px' });
    observer.observe(wrap);
  }
})();

/* ---------- Collection: client-side search (filters currently loaded cards) ---------- */
(function(){
  const input = document.querySelector('[data-collection-search]');
  if(!input) return;
  const grid = document.querySelector('[data-product-grid]');
  const noMatch = document.querySelector('[data-no-search-match]');
  const resultCount = document.querySelector('[data-result-count]');

  input.addEventListener('input', () => {
    const query = input.value.trim().toLowerCase();
    if(!grid) return;
    const cards = grid.querySelectorAll('.product-card');
    let visible = 0;
    cards.forEach(card => {
      const title = (card.querySelector('.product-card__title')?.textContent || '').toLowerCase();
      const match = query === '' || title.includes(query);
      card.style.display = match ? '' : 'none';
      if(match) visible++;
    });
    if(noMatch) noMatch.hidden = visible > 0 || query === '';
    if(resultCount && query !== ''){
      resultCount.textContent = visible + ' matching product' + (visible !== 1 ? 's' : '');
    }
  });
})();

/* ---------- Buy Now (product page) ---------- */
document.querySelectorAll('[data-buy-now]').forEach(btn=>{
  btn.addEventListener('click', function(){
    const form = btn.closest('form');
    if(!form) return;
    const formData = new FormData(form);
    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = 'Redirecting...';
    fetch('/cart/add.js', { method:'POST', body: formData })
      .then(r => {
        if(!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(() => {
        window.location.href = '/checkout';
      })
      .catch(() => {
        btn.disabled = false;
        btn.textContent = originalText;
      });
  });
});

/* ---------- Quick Add / Quick Buy (product cards on grids) ---------- */
function quickAddToCart(variantId, quantity){
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', quantity || 1);
  return fetch('/cart/add.js', { method:'POST', body: formData }).then(r=>{
    if(!r.ok) throw new Error('Add to cart failed');
    return r.json();
  });
}

document.querySelectorAll('[data-quick-add]').forEach(btn=>{
  btn.addEventListener('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    const variantId = btn.dataset.variantId;
    if(!variantId) return;
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    quickAddToCart(variantId, 1)
      .then(() => {
        btn.textContent = 'Added ✓';
        setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 1200);
        openCartDrawer();
      })
      .catch(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      });
  });
});

document.querySelectorAll('[data-quick-buy]').forEach(btn=>{
  btn.addEventListener('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    const variantId = btn.dataset.variantId;
    if(!variantId) return;
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Redirecting...';
    quickAddToCart(variantId, 1)
      .then(() => { window.location.href = '/checkout'; })
      .catch(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      });
  });
});
